// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EB4D7b4Ee8WVpgkQzXlU{width:228px}.G5Av34GEx_Qt4ObiOVUU{padding:4px}.lm7WhpSevqc8C54Jknn8{cursor:pointer;border-radius:4px;justify-content:flex-start;align-items:center;gap:8px;padding:8px 8px 8px 12px;font-size:13px;font-weight:400;display:flex}.lm7WhpSevqc8C54Jknn8 .AlONdT96RsA7Ulha8P9R{color:var(--content-primary-primary)}.lm7WhpSevqc8C54Jknn8:hover{background:var(--background-neutral-subtle)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `EB4D7b4Ee8WVpgkQzXlU`,
	"items": `G5Av34GEx_Qt4ObiOVUU`,
	"item": `lm7WhpSevqc8C54Jknn8`,
	"label": `AlONdT96RsA7Ulha8P9R`
};
export default ___CSS_LOADER_EXPORT___;
